// Author Post List
import { initLazyload } from "./lazyload";

let authorPostListAbort = null;

export const initAuthorPostList = () => {
  if (authorPostListAbort) {
    authorPostListAbort.abort();
  }

  const authorPostList = document.querySelector(".author-post-list");
  const loadMoreBtn = document.querySelector(".author-post-list .author-post-list__btn");
  const blogLoader = document.querySelector(".author-post-list .blog-post-loader");

  if (!authorPostList || !loadMoreBtn) {
    return;
  }

  authorPostListAbort = new AbortController();
  const { signal } = authorPostListAbort;

  loadMoreBtn.addEventListener(
    "click",
    () => {
      const hiddenItems = authorPostList.querySelectorAll(".col-md-6.col-lg-6.d-none");

      if (hiddenItems.length === 0) {
        loadMoreBtn.style.display = "none";
        return;
      }

      blogLoader?.classList.remove("d-none");
      loadMoreBtn.style.display = "none";

      setTimeout(() => {
        const itemsToShow = Math.min(2, hiddenItems.length);

        for (let i = 0; i < itemsToShow; i++) {
          hiddenItems[i].classList.remove("d-none");
        }

        initLazyload();

        blogLoader?.classList.add("d-none");

        const remainingHidden = authorPostList.querySelectorAll(".col-md-6.col-lg-6.d-none");
        if (remainingHidden.length > 0) {
          loadMoreBtn.style.display = "";
        }
      }, 1500);
    },
    { signal }
  );
};

if (document.querySelector(".author-post-list")) {
  initAuthorPostList();
}
